<template>
  <div>

  <v-layout>
    <v-flex xs12>
      <v-container fluid grid-list-xl>
        <v-layout row wrap>

          <v-flex  xs6>
            <!-- ####### Parcel Number Consumption Chart ############ -->
            <v-card>
              <v-card-title  >
                <span  class="headline">Parcel Number Consumption</span>
              </v-card-title>
              <v-alert type="error" :value="parcelNumberContainerConsumptionError">{{parcelNumberContainerConsumptionError}}</v-alert>
              <v-card-text>
                <bar-chart :chart-data="parcelNumberContainerConsumptionBarChartData.datacollection"  :scalesdisplay="false" :width="350" :height="200"  :options="parcelNumberContainerConsumptionBarChartDataOptions" ></bar-chart>
              </v-card-text>
            </v-card>
          </v-flex>

          <v-flex  xs6>
            <!-- ####### Returns Quantity Chart ############ -->
            <v-card>
              <v-card-title  >
                <span  class="headline">Returns Quantity</span>
              </v-card-title>
              <v-alert type="error" :value="returnQuantityBarChartDataError">{{returnQuantityBarChartDataError}}</v-alert>
              <v-card-text>
                <bar-chart :chart-data="returnQuantityBarChartData.datacollection"  :scalesdisplay="false" :width="350" :height="200"  :options="returnQuantityBarChartDataOptions" ></bar-chart>
              </v-card-text>
            </v-card>

          </v-flex>

          <v-flex  xs12 sm6>
            <v-card>
              Version: <b>{{version}}</b>
            </v-card>
          </v-flex>

          <v-flex  xs12 sm6>
            <v-card>
              Build-Time: <b>{{buildTime}}</b>
            </v-card>
          </v-flex>

        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>

  </div>
</template>

<script>
  //import LineChart from '../components/LineChart.js'

  import PieChart from '../pie-chart.js';
  import BarChart from '../bar-chart.js';

  import axios from 'axios';
  import isoc from 'isoc';
  import DataService from '../services/data';

  export default {
    components: {
      PieChart,
      BarChart
    },
    data () {
      return {
        parcelNumberContainerConsumptionError: null,
        parcelNumberContainerConsumptionBarChartData: {
          datacollection: {}
        },    
        parcelNumberContainerConsumptionBarChartDataOptions:{
          legend: {
          	display: true
          },
          title: {
            display: false,
            text: 'Oversikt',
            fontSize: 30,
            padding:10
          },
          tooltips: {
            mode: 'label',
              callbacks: {
                label: function(tooltipItem, data) {
                  return data.datasets[tooltipItem.datasetIndex].label + ": " +tooltipItem.xLabel+" %";
                }
              }
          },
          scales: {
          	yAxes: [{
              stacked: true,
              gridLines: { display: false },
              scaleLabel: {
              	display: true
              }
            }],
            xAxes: [{
              stacked: true,
                gridLines: { display: false },
                scaleLabel: {
                  display: false
                },
                ticks: {
                  callback: function(tick) {
                    return tick.toString() + '%';
                  }
                }
            }],
          }, // scales
        },
        returnQuantityBarChartDataError: null,
        returnQuantityBarChartData: {
          datacollection: {}
        },
        
        returnQuantityBarChartDataOptions:{
            legend: {
              display: false
            },
            title: {
              display: false,
              text: 'Oversikt',
              fontSize: 30,
              padding:0
            },
            scales: {
                  xAxes: [{
                    stacked: true,
                    gridLines: { display: false },
                    }],
                  yAxes: [{
                    stacked: true,
                     gridLines: { display: false },
                    }],
                }, // scales
        },

        version: profileConfig.meta.version,
        buildTime: profileConfig.meta.buildTime
      }
    },

    created() {
      console.log('=====> create ');
      this.dataService = new DataService(this.profile, this.$store.state.tokens);

        return Promise.all([
          this.dataService.getParcelNumberContainersConsumption(1,50),
          this.dataService.getReturnsQuantity(1,50)

        ]).then(([ parcelNumberContainerConsumptionResp, returnsQuantityResp]) => {
           
            //create chart for parcel Number Container Consumption
            if(parcelNumberContainerConsumptionResp.data.length>0){
              let parcelNumberContainerConsumption = parcelNumberContainerConsumptionResp.data;
              var containerNames = [];
              let chartDataInfos =[];
              var freeInfoData=[];
              var reservedInfoData=[];
              var consumedInfoData=[];

              parcelNumberContainerConsumption.forEach(function(element) {
                  containerNames.push(element.containerName);
                  reservedInfoData.push(Math.round( (element.reserved / element.size )* 100) );
                  consumedInfoData.push(Math.round( (element.consumed/ element.size )* 100) );
                  freeInfoData.push( Math.round( ((element.size - element.consumed - element.reserved) / element.size )* 100 ) );
              });

              var reservedInfo ={
                 label: 'reserved',
                 data: reservedInfoData,
                 backgroundColor: "#F2F5A9",
                 borderColor: '#D7DF01'
              };

              var freeInfo ={
                   label: 'free',
                   data: freeInfoData,
                   backgroundColor: "#A9F5A9",
                   borderColor: '#01DF01'
              };

              var consumedInfo ={
                   label: 'consumed',
                   data: consumedInfoData,
                   backgroundColor: "#F5A9A9",
                   borderColor: '#FF0000'
              };
              chartDataInfos.push(reservedInfo);
              chartDataInfos.push(freeInfo);
              chartDataInfos.push(consumedInfo);
              this.parcelNumberContainerConsumptionBarChartData = this.fillBarChartDataSet(containerNames , chartDataInfos);
            }


            console.log('getReturnsQuantity :' , returnsQuantityResp.data);
            if(returnsQuantityResp.data.length>0){
              let returnsQuantity = returnsQuantityResp.data;
              returnsQuantity.sort(function(a, b) {
                return a.count <= b.count;
            });

              var portalNames = [];
              var chartData = [];
              returnsQuantity.forEach(function(element) {
                  portalNames.push(element.uuid);
                  chartData.push(element.count);
              });
              this.returnQuantityBarChartData = this.fillBarChartData(portalNames , chartData);
            }



            })
            .catch(err => {
              if (err.response) {
                console.log('########  Error : ' , err);
                this.returnQuantityBarChartDataError = err.response.data.message;
                this.parcelNumberContainerConsumptionBarChartDataError = err.response.data.message;

              } else {
                console.log('######### Error: ' , err);
                this.returnQuantityBarChartDataError = 'Network Error';
                this.parcelNumberContainerConsumptionBarChartDataError = 'Network Error';
              };
       });
    },

    methods: {

      fillBarChartDataSet (labelNames , chartDataInfos) {
        var barChartData= {
              datacollection: {
                  labels: null,
                  datasets: []
              }
        };

        barChartData.datacollection.labels =labelNames;
        chartDataInfos.forEach(function(chartDataInfo) {
          let chartData = {
                        label : chartDataInfo.label,
                        data: chartDataInfo.data,
                        backgroundColor: chartDataInfo.backgroundColor,
                        borderColor : chartDataInfo.borderColor,
                        hoverBorderWidth: 1,
                      };
          barChartData.datacollection.datasets.push(chartData);
        });
        return barChartData;
      },

      fillBarChartData (labelNames , chartData) {
        let barChartData={}
        barChartData.datacollection = {
          labels:labelNames,
          datasets: [
            {
              data: chartData,
              backgroundColor: '#A9BCF5',
              hoverBackgroundColor: '#8080ff',
              borderColor : '#ffff80'
            }
          ]
        }
        return barChartData;
      }

    }
  }
</script>

<style>
  .small {
    max-width: 400px;
  }
</style>



// WEBPACK FOOTER //
// Dashboard.vue?0f6f3d1c